import React from 'react';
import { object, bool } from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash';
import { Base } from '@fiverr-private/modal/src';
import { Button, Icon } from '@fiverr-private/fit';
import { s_play_circle } from '@fiverr-private/icons';
import listingsTracker from '../../../../apps/listings/service/tracker';
import categoryTracker from '../../../../apps/categories/service/tracker';
import ModalBody from '../ModalBody';
import { GENERAL_VIDEO_MODAL_NAME, VIDEO_PROP_TYPES } from '../constants';
import './index.scss';

const ExplanationVideo = ({
    hasVideoLink = false,
    subcat = {},
    isCategoryPage = false,
    hasBorder = true,
    onOpen = noop,
    className,
    video,
    videoTitle,
    sourceInfo
}) => {

    const handleOpen = () => {
        if (onOpen !== noop) {
            onOpen();
        } else {
            const { categoryName, title } = subcat;
            const tracker = isCategoryPage ? categoryTracker : listingsTracker;

            tracker.trackHowFiverrWorksVideo({ categoryName, subcategoryName: title });
        }
    };

    const playBtnClass = classNames(
        'btn-play',
        { 'separated-video-link': hasVideoLink },
        { 'without-border': !hasBorder }
    );

    return (
        <div className={classNames('explanation-video', className)}>
            {subcat.subtitle && <p className="sc-subtitle">{subcat.subtitle}</p>}
            <Base name={GENERAL_VIDEO_MODAL_NAME}
                onOpen={handleOpen}
                trigger={({ open }) => (
                    <Button className={playBtnClass} size={Button.SIZES.SMALL} onClick={open}>
                        <Icon size={14} className="play-icon">{s_play_circle}</Icon>
                        {videoTitle}
                    </Button>
                )}>
                {() => <ModalBody video={video} sourceInfo={sourceInfo}/>}
            </Base>
        </div>
    );
};

ExplanationVideo.propTypes = {
    ...VIDEO_PROP_TYPES,
    subcat: object,
    hasVideoLink: bool,
    isCategoryPage: bool
};

export default ExplanationVideo;
